[
    {
        "literal": "artifact_updated",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ArtifactUpdatedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "assistant_image",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ImagePayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "assistant_reasoning",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_TextPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "assistant_text",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_AssistantTextPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "automation_run_requested",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_AutomationRunRequestedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "child_completed",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ChildCompletedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "domain_event_observed",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_DomainEventObservedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "file_ref",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_FileRefPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "interrupt_requested",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ReasonPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "item_compaction",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ItemCompactionPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "item_other",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ItemOtherPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "observed_outreach_updated",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ObservedOutreachUpdatedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "outreach_kickoff",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_OutreachKickoffPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "outreach_monitor_wake_up",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_OutreachMonitorWakeUpPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "outreach_runner_kickoff",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_OutreachRunnerKickoffPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "page_context_init",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_PageContextInitPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "poke",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_PokePayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "retry_tool_call",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_RetryToolCallPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_cancel_requested",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ReasonPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_cancelled",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ReasonPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_completed",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_RunCompletedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_failed",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_RunFailedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_interrupted",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ReasonPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_provider_retrying",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_RunProviderRetryingPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "run_started",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_EmptyPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "slack_thread_message",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_SlackThreadMessagePayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "staff_imessage_approval_decision",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_StaffImessageApprovalDecisionPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "staff_imessage_notification_sent",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_StaffImessageNotificationSentPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "staff_imessage_reaction",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_StaffImessageReactionPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "status_update",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_StatusUpdatePayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "stop_requested",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ReasonPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "subagent_init",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_SubAgentInitPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "thread_summary",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ThreadSummaryPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "tool_approval_denied",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandDeniedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "tool_approval_granted",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandDeniedPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "tool_approval_required",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "tool_call",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ToolCallPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "tool_output",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ToolOutputPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "user_image",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_ImagePayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "user_message",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_TextPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "user_question_answered",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "user_question_cancelled",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "user_question_required",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_CommandPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    },
    {
        "literal": "watch",
        "payload_model": "services.api.routes.organizations.phoebe_agent_runs.event_feed_payload_models:_WatchPayload",
        "bazel_target": "//services/api/routes/organizations/phoebe_agent_runs:phoebe_agent_runs",
        "producer_enabled": true
    }
]
